export const SETCOUNTRYLIST = "SETCOUNTRYLIST";
export const CLEARDOC = "CLEARDOC";
export const SETCUSTOMERLIST = "SETCUSTOMERLIST";
export const SETCUSTOMERFILTERLIST = "SETCUSTOMERFILTERLIST";
export const SETCUSTOMERDETAIL = "SETCUSTOMERDETAIL";
export const SETALLCONTACTPERSONLIST = "SETALLCONTACTPERSONLIST";
export const SETCUSTOMERBASICFILTERDATA = "SETCUSTOMERBASICFILTERDATA";
